














import { Component, Vue, Prop } from 'vue-property-decorator';
import DragHandler from '../DragHandler';
import { IPos, zeroPos, noop, fixMatrixNumber } from '@/misc';

@Component
export default class SvgDragPoint extends Vue {
  @Prop() protected title!: string;
  @Prop() protected color!: string;
  @Prop() protected calm!: boolean;
  @Prop(Number) protected x!: number;
  @Prop(Number) protected y!: number;
  @Prop({ default: noop }) protected onMove!: (diff: IPos) => void;
  @Prop({ default: noop }) protected onEnd!: (diff: IPos) => void;

  protected dragHandler = new DragHandler();

  protected get sx() {
    // TODO remove magic number
    return fixMatrixNumber((this.x) / 100);
  }

  protected get sy() {
    // TODO remove magic number
    return fixMatrixNumber((this.y) / 100);
  }

  constructor() {
    super();
  }

  public mounted() {
    this.dragHandler.start({
      el: this.$el,
      onEnd: (diff) => this.onDragEnd(diff),
      onMove: (diff) => this.onDragMove(diff),
    });
  }

  public destroyed() {
    this.dragHandler.stop();
  }

  public onDragMove(diff: IPos) {
    if (this.onMove) {
      this.onMove(diff);
    }
  }

  public onDragEnd(diff: IPos) {
    if (this.onEnd) {
      this.onEnd(diff);
    }
  }
}
